export default "__VITE_ASSET__82b72cb9__"